"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlayerTypes = /** @class */ (function () {
    function PlayerTypes() {
    }
    PlayerTypes.prototype.getPlayerTypes = function () {
        return [
            { "name": "Unknown", "icon": "/images/globe.svg" },
            { "name": "WebPlayer", "icon": "/images/globe.svg" },
            { "name": "Linux", "icon": "/images/linux.svg" },
            { "name": "ChromeOS", "icon": "/images/chrome.svg" },
            { "name": "Windows", "icon": "/images/windows.svg" },
            { "name": "Raspberry PI", "icon": "/images/raspberry-pi.svg" },
            { "name": "LG", "icon": "/images/lg.svg" },
            { "name": "Android", "icon": "/images/android.svg" },
            { "name": "Samsung", "icon": "/images/samsung.svg" },
            { "name": "Samsung", "icon": "/images/samsung.svg" }
        ];
    };
    PlayerTypes.prototype.getPlayerTypeIconByDeviceId = function (deviceId) {
        if (deviceId < this.getPlayerTypes().length) {
            return this.getPlayerTypes()[deviceId].icon;
        }
        return this.getPlayerTypes()[0].icon;
    };
    return PlayerTypes;
}());
exports.default = new PlayerTypes();
